// Publiczny hook odrzucenia oferty - PUT /sales-crm/public-offers/{token}/reject
// BEZ OAuth (uzywa publicAxios).

import publicAxios from 'api/publicAxios';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutPublicOfferRejectPayload {
  confirm: true;
  comment?: string;
}

const putPublicOfferReject = (
  token: string,
  payload: IPutPublicOfferRejectPayload
): Promise<ICommandResponseSuccess> =>
  publicAxios.put(`/sales-crm/public-offers/${token}/reject`, payload);

export const usePutPublicOfferReject = (
  token: string,
  options?: UseMutationOptions<ICommandResponseSuccess, IError, IPutPublicOfferRejectPayload>
) =>
  useMutation(
    (payload: IPutPublicOfferRejectPayload) => putPublicOfferReject(token, payload),
    options
  );
